// extracted by mini-css-extract-plugin
export var wordContainer = "_oy-0";